import crypto from 'crypto';

export const sha256Hash = (str: string): string =>
	crypto.createHash('sha256').update(str).digest('hex');
